export default __webpack_public_path__ + "locales/vi/Files.json?hash=ed8275b0d15484de92a53340f579df3f";